import authRequestsSlice from "./auth/auth";
import storesRequestsSlice from "./stores/stores";
import subscriptionRequestsSlice from "./subscriptions/subscriptions";
import usersRequestsSlice from "./users/users";
import whitelistRequestsSlice from "./whitelist/whitelist";

export const { useLoginMutation, useRegisterMutation, useSetPasswordMutation, useRequestResetPasswordMutation } = authRequestsSlice;

export const { useStartCheckoutMutation, useUpgradePlanMutation } = subscriptionRequestsSlice;

export const { useAddStoreMutation, useGetStoresQuery, useEditStoreMutation } = storesRequestsSlice;

export const {useInviteSubUserMutation, useGetSubUsersQuery, useDeleteSubUserMutation, useResendSubUserInviteMutation} = usersRequestsSlice;

export const { 
  useGetWhitelistedIpsQuery,
  useAddIPMutation,
  useSyncMyIPMutation,
  useEditIPAddressMutation,
  useDeleteIPAddressMutation,
} = whitelistRequestsSlice;
